import { ScheduleItem } from '@/integrations/supabase/client';

export const day2Data: ScheduleItem[] = [
  {
    id: "day2-keynote-exploring-mythos",
    day: "day2",
    start_time: "09:00",
    end_time: "09:20",
    title: "Keynote I: Exploring Mythos",
    description: null,
    location: "Main Hall",
    type: "Keynote",
    speaker: { name: "Charles Ahlborn, MPS Lead for AI/ML Cyber Risk and Assurance, Cyber Security Risk Analyst | Digital, Data, and Technology | Metropolitan Police Services" }
  },
  {
    id: "day2-keynote-data-ecosystems",
    day: "day2",
    start_time: "09:20",
    end_time: "09:40",
    title: "Keynote II: Building an Insight Driven Sales Process",
    description: null,
    location: "Main Hall",
    type: "Keynote",
    speaker: { name: "Aarushi Kansal, Futurice AI Director, FUTURICE" }
  },
  {
    id: "day2-keynote-ai-governance",
    day: "day2",
    start_time: "09:40",
    end_time: "10:00",
    title: "Keynote III: AIoT in Action: Operating Edge AI and Agentic AI at scale",
    description: null,
    location: "Main Hall",
    type: "Keynote",
    speaker: { name: "Kanishk Chaturvedi, Director AI Ecosystem, Cumulocity" }
  },
  {
    id: "day2-keynote-cyber-defense",
    day: "day2",
    start_time: "10:00",
    end_time: "10:20",
    title: "Keynote IV: From AI Experimentation to Scaled AI Value Creation",
    description: null,
    location: "Main Hall",
    type: "Keynote",
    speaker: { name: "Speaker TBC" }
  },
  {
    id: "day2-networking-break-1",
    day: "day2",
    start_time: "10:20",
    end_time: "10:50",
    title: "Networking Break (Teas & Snacks)",
    description: null,
    location: "Networking Area",
    type: "Break",
    speaker: null
  },
  {
    id: "day2-keynote-agi",
    day: "day2",
    start_time: "10:50",
    end_time: "11:10",
    title: "Keynote V: Exploring Intersection of AI and AR",
    description: null,
    location: "Main Hall",
    type: "Keynote",
    speaker: { name: "Mark Sage, Executive Director, AREA" }
  },
  {
    id: "day2-keynote-ar",
    day: "day2",
    start_time: "11:10",
    end_time: "11:30",
    title: "Building a Domain Specific Enterprise AI solutions at Scale",
    description: null,
    location: "Main Hall",
    type: "Keynote",
    speaker: { name: "Microsoft (Speaker TBC)" }
  },
  {
    id: "day2-panel-challenges",
    day: "day2",
    start_time: "11:30",
    end_time: "12:30",
    title: "Panel Session: Emerging Challenges & Opportunities in AI Industry",
    description: "Moderator: Philip Hooker, Chief Operating Officer (COO), CUMULOCITY\n\nPanelists:\n- Speaker TBC\n- Aarushi Kansal, Futurice AI Director, FUTURICE\n- Kanishk Chaturvedi, Director AI Ecosystem, Cumulocity\n- Mark Sage, Executive Director, AREA",
    location: "Main Hall",
    type: "Panel",
    speaker: null
  },
  {
    id: "day2-lunch-break",
    day: "day2",
    start_time: "12:30",
    end_time: "13:30",
    title: "Lunch Break with Networking",
    description: null,
    location: "Dining Area",
    type: "Break",
    speaker: null
  },
  {
    id: "day2-ai-agents-infrastructure",
    day: "day2",
    start_time: "13:30",
    end_time: "13:45",
    title: "How to drive value from Gen AI at enterprises",
    description: null,
    location: "Main Hall",
    type: "Session",
    speaker: { name: "Puneet Jindal - Global Data Science Senior Director & AI CoE Lead" }
  },
  {
    id: "day2-aiot-opportunities",
    day: "day2",
    start_time: "13:45",
    end_time: "14:00",
    title: "Exploring Agentic AI Config Generation, Verification and Execution Layer",
    description: null,
    location: "Main Hall",
    type: "Session",
    speaker: { name: "Speaker TBC" }
  },
  {
    id: "day2-enabling-ai-connectivity",
    day: "day2",
    start_time: "14:00",
    end_time: "14:15",
    title: "Impact of AI in Banking and Financial Services",
    description: null,
    location: "Main Hall",
    type: "Session",
    speaker: { name: "Polina Beqiraj, Management Consultant · ABN AMRO Bank N.V" }
  },
  {
    id: "day2-ai-grid",
    day: "day2",
    start_time: "14:15",
    end_time: "14:30",
    title: "Autonomous Minds: How Agentic AI Predicts and Learns to Enable Productivity and Empowerment",
    description: null,
    location: "Main Hall",
    type: "Session",
    speaker: { name: "Javier Campos, Group CTO, CAPE" }
  },
  {
    id: "day2-networking-break-2",
    day: "day2",
    start_time: "14:30",
    end_time: "15:00",
    title: "Networking Break (Teas & Snacks)",
    description: null,
    location: "Networking Area",
    type: "Break",
    speaker: null
  },
  {
    id: "day2-thinking-beyond-ai-deployment",
    day: "day2",
    start_time: "15:00",
    end_time: "15:15",
    title: "Thinking Beyond AI Deployment",
    description: null,
    location: "Main Hall",
    type: "Session",
    speaker: { name: "Camilla Sammut-Powell, PhD, AI Specialist and Principal, SLALOM" }
  },
  {
    id: "day2-human-ai",
    day: "day2",
    start_time: "15:15",
    end_time: "15:30",
    title: "Governing The Agents You Didn't Build",
    description: null,
    location: "Main Hall",
    type: "Session",
    speaker: { name: "Speaker TBC" }
  },
  {
    id: "day2-ai-testing",
    day: "day2",
    start_time: "15:30",
    end_time: "15:45",
    title: "AI Ethics in Climate Technology—Building Responsible Solutions",
    description: null,
    location: "Main Hall",
    type: "Session",
    speaker: { name: "Jennifer Stirrup, Director, Data Relish Ltd" }
  },
  {
    id: "day2-closing",
    day: "day2",
    start_time: "15:45",
    end_time: "16:00",
    title: "Future of AI in Marketing",
    description: null,
    location: "Main Hall",
    type: "Session",
    speaker: { name: "Steffan Saxton‑Williams, AI Delivery Director, FOUR Agency" }
  }
];
